export enum LinuxServiceActiveState {
    Active = 'active',
    Inactive = 'inactive',
    Failed = 'failed',
    Activating = 'activating',
    Deactivating = 'deactivating',
    Maintenance = 'maintenance',
    Reloading = 'reloading',
}
